module.exports = __webpack_public_path__ + "media/images/badgerart01-6944a2761aca7bd38251b41ac2f90d15.png";